import React, { Component } from 'react';
import { Big3Common } from '../../../js/IncludeManager'

import { Swiper, SwiperSlide } from "swiper/react";
import { Thumbs, Zoom } from 'swiper';

import "swiper/css";
import 'swiper/css/thumbs';

/* 개발담당:양유빈
 * 화면기능:플랫폼 메인 페이지
 * 세부설명:
*/

export class GoodsZoom extends Component {
    static displayName = GoodsZoom.name;

    constructor(props) {
        super(props);
        this.state = {
            ImageList: [],
            ImageNumber: 1,
            FirstImage: "",
            thumbsSwiper: null
        };
        this.CsName = Big3Common.ContentState;

        this.GoodsPhotoModel = [];

        if (this.props.ContentState !== undefined) {
            this.GoodsPhotoModel = this.props.ContentState.GoodsPhotoModel !== undefined ? this.props.ContentState.GoodsPhotoModel : [];
        }
    }
    //초기화
    async componentDidMount() {
        await this.CallGoodsData();
    }
    async CallGoodsData() {
        try {

            this.setState({ ImageList: this.GoodsPhotoModel });
        }
        catch (e) {
            console.log("CallGoodsData: ", e)
        }
        return false;
    }

    render() {
        let GoodsPhotoList = this.state.ImageList;
        if (GoodsPhotoList.length === 0) return;

        let VirtualRoot = Big3Common.WebConfig.GoodsImageVirtualPath();
        let LayoutWidth = Big3Common.Util.offsetWidth();
        let slidersCount = 13;
        slidersCount = Math.ceil(LayoutWidth / 100) - 1;
        if (slidersCount >= 13) {
            slidersCount = 13;
        }
        else if (slidersCount <= 5) {
            slidersCount = 5;
        }
        return (
            <div className="detail_img_page">
                <Swiper
                    spaceBetween={10}
                    navigation={false}
                    className="mySwiper2"
                    zoom={true}
                    modules={[Zoom, Thumbs]}
                    thumbs={{ swiper: this.state.thumbsSwiper }}
                >
                    <>
                        {
                            GoodsPhotoList.map((list, idx) =>
                                <SwiperSlide key={list.rownum}
                                >
                                    <div className="img_box swiper-zoom-container">
                                        <img src={VirtualRoot + list.img_1000} alt="상품사진" />
                                    </div>
                                </SwiperSlide>
                            )}
                    </>
                </Swiper>
                <Swiper watchSlidesProgress={true}
                    slidesPerView={slidersCount}
                    className="mySwiper img_list_box"
                    modules={[Thumbs]}
                    onSwiper={(swiper) => this.setState({ thumbsSwiper: swiper })}
                >
                    <div>
                        {
                            GoodsPhotoList.map(list =>
                                <SwiperSlide key={list.rownum} className="img_list"
                                    style={{ backgroundImage: `url(${VirtualRoot}${list.img_100})`, "width": "65px", height: "65px" }}
                                >
                                </SwiperSlide>
                            )}
                        <SwiperSlide style={{ width: "65px", height: "65px" }}>
                            {/* 공백*/}
                        </SwiperSlide>
                    </div>
                </Swiper>
            </div>
        );
    }
}
